<gbc-table>
  <th gbc-table-header>Product Name</th>
  <th gbc-table-header>Error Codes</th>
  <th gbc-table-header>Title</th>
  <th gbc-table-header>Conditions</th>
  <th gbc-table-header>Cause</th>
  <th gbc-table-header>Remedy Steps</th>


  @for (metadata of metadatas$ | async; track metadata) {
    <tr gbc-table-row>
      <td class="errorCode">{{metadata.productName}}</td>
      <td class="errorCode">{{metadata | formatAlarmMetadata }}</td>
      <td class="title">{{metadata.title}}</td>
      <td class="conditions">
        @if (metadata.conditions && metadata.conditions.length > 0) {
          <ol>
            @for (condition of metadata.conditions; track condition) {
              <li>{{condition.value}}</li>
            }
          </ol>
        }
      </td>
      <td class="cause">
        @if (metadata.causes && metadata.causes.length > 0) {
          <ol>
            @for (cause of metadata.causes; track cause) {
              <li>{{cause.description}}</li>
            }
          </ol>
        }
      </td>
      <td class="remedySteps">
        @if (metadata.causes?.length > 0 && metadata.causes[0]?.remedySteps?.length > 0) {
          <ol>
            @for (remedyStep of metadata.causes[0].remedySteps; track remedyStep) {
              <li>{{remedyStep.command}}</li>
            }
          </ol>
        }
      </td>
    </tr>
  }
</gbc-table>
